import { useEffect, useState } from "react";

const navLinks = [
  { href: "#ranking", label: "排行榜" },
  { href: "#category", label: "分类大全" },
  { href: "#completed", label: "完结漫画" },
  { href: "#fansub", label: "汉化专区" },
  { href: "#picks", label: "编辑精选" },
  { href: "#about", label: "用户口碑" },
  { href: "#faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "border-b border-background-200/70 bg-background-50/90 shadow-sm backdrop-blur"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-lg ${
              scrolled ? "bg-primary-500 text-background-50" : "bg-background-50/20 text-background-50 backdrop-blur"
            }`}
          >
            <i className="ri-book-2-fill text-lg"></i>
          </span>
          <span
            className={`font-heading text-xl font-bold ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            动漫之家漫画网
          </span>
        </a>

        <nav className="hidden items-center gap-7 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`whitespace-nowrap text-sm font-medium transition-colors ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-600"
                  : "text-background-100 hover:text-white"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#completed"
            className={`hidden whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium transition-colors sm:block ${
              scrolled
                ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                : "bg-background-50/20 text-background-50 backdrop-blur hover:bg-background-50/30"
            }`}
          >
            开始看漫画
          </a>
          <button
            onClick={() => setOpen((v) => !v)}
            aria-label="打开导航菜单"
            className={`flex h-10 w-10 items-center justify-center rounded-md transition-colors lg:hidden ${
              scrolled
                ? "text-foreground-900 hover:bg-background-100"
                : "text-background-50 hover:bg-background-50/20"
            }`}
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 py-4 lg:hidden">
          <nav className="grid grid-cols-2 gap-2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2 text-sm font-medium text-foreground-700 hover:bg-background-100 hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}